import React from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";

const data2 = {
  labels: ["SBIR Phase I", "SBIR Phase II"],
  datasets: [
    {
      type: "bar",
      label: "Award Count",
      data: [3, 1],
    },
    {
      type: "line",
      label: "Award Amount",
      data: [165000, 156767],
      borderColor: "#ffffff",           // white line
      backgroundColor: "transparent",   // no fill
      borderWidth: 4,                   // thick line
      tension: 0.3,
      pointBackgroundColor: "#ffffff",
      pointBorderColor: "#ffffff",
      pointRadius: 4,
    },
  ],
};

const data3 = {
  labels: ["SBIR Phase I", "SBIR Phase II"],
  datasets: [
    {
      type: "bar",
      label: "Award Count",
      data: [3, 1],
    },
    {
      type: "line",
      label: "Line Dataset",
      data: [50, 50],
      borderColor: "#ffffff",
      backgroundColor: "transparent",
      borderWidth: 4,
      tension: 0.3,
      pointBackgroundColor: "#ffffff",
      pointBorderColor: "#ffffff",
      pointRadius: 4,
    },
  ],
};

const LineChart = ({ data, adId }) => {
  const graphClickEvent = (event, elements) => {
    if (elements.length > 0) {
      const element = elements[0];
      if (element.datasetIndex === 0 || element.datasetIndex === 1) {
        if (!window.location.href.includes("chart-details"))
          window.open(`/chart-details/${adId}`, "_blank");
      }
    }
  };

  // ✅ updated options – linear scale + white UI
  const options = {
    scales: {
      y: {
        type: "linear", // 👈 logarithmic se linear kiya
        ticks: {
          color: "white",
          callback: function (value) {
            return value.toLocaleString();
          },
        },
        grid: {
          color: "rgba(255,255,255,0.2)",
        },
      },
      x: {
        ticks: {
          color: "white",
        },
        grid: {
          color: "rgba(255,255,255,0.2)",
        },
      },
    },
    plugins: {
      legend: {
        labels: {
          color: "white",
        },
      },
    },
    onClick: graphClickEvent,
  };

  return <Line data={data} options={options} />;
};

export default LineChart;
